import React from "react";

export default function WhatWeDo() {
  const [isVisible, setIsVisible] = React.useState(false);
  const sectionRef = React.useRef(null);

  React.useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect(); // Trigger once
        }
      },
      { threshold: 0.3 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  // Text Splitting Logic
  const renderAnimatedText = (text, isHighlight = false, startIndex = 0) => {
    let charIndexCounter = 0;
    const parts = text.split(/(\s+)/); // Split by whitespace capturing it

    return parts.map((part, pIndex) => {
      // If part is whitespace, render it as text node for normal wrapping behavior
      if (part.match(/\s/)) {
        return part;
      }

      // If it's a word, wrap it in a nowrap container
      if (part.length === 0) return null;

      const wordChars = part.split("");
      const wordElement = (
        <span key={pIndex} style={{ display: "inline-block", whiteSpace: "nowrap" }}>
          {wordChars.map((char, cIndex) => (
            <span
              key={cIndex}
              className={`anim-letter ${isHighlight ? "highlight-letter" : ""}`}
              style={{ animationDelay: `${(startIndex + charIndexCounter + cIndex) * 0.03}s` }}
            >
              {char}
            </span>
          ))}
        </span>
      );
      charIndexCounter += wordChars.length;
      return wordElement;
    });
  };

  return (
    <section className="editorial-section" id="what-we-do" ref={sectionRef}>
      <div className="editorial-container">

        {/* Left Side: The Statement */}
        <div className="editorial-content">
          <span className="editorial-label">What We Do</span>

          {/* Animated Heading */}
          <h2 className={`editorial-statement ${isVisible ? "animate-text-visible" : ""}`}>
            {/* "At " */}
            {renderAnimatedText("At ", false, 0)}

            {/* "Bandham" (Highlight) */}
            {renderAnimatedText("Bandham", true, 3)}

            {/* ", every stitch carries an idea crafted with purpose." */}
            {renderAnimatedText(", every stitch carries an idea crafted with purpose.", false, 10)}
          </h2>

          <p className="editorial-sub">
            We turn your thoughts into handcrafted embroidery — portraits, hoops, crochets, accessories, and more.
            Clean detailing, refined textures, and creations that feel truly personal.
          </p>

          <a href="#collections" className="editorial-link">
            Explore More
          </a>
        </div>

        {/* Right Side: Image */}
        <div className="editorial-media">
          <div className="image-backdrop"></div>
          <img
            src="images/favicon.png"
            alt="Bandham Handcrafted Piece"
            className="editorial-img"
          />
        </div>

      </div>
    </section>
  );
}
